module.exports = __webpack_public_path__ + "static/img/leftBack.8092f75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logistics/leftBack.png
// module id = xoCy
// module chunks = 44